/* eslint-disable react-refresh/only-export-components */
import React from 'react';
import { cn } from '@/lib/utils';

export const sectionHeader =
  'font-heading text-xs font-semibold uppercase tracking-wide text-muted-foreground';
export const sectionUnderline = 'border-b border-primary/40 inline-block pb-1 mb-3';

export const billingBadgeBase =
  'font-mono text-[10px] sm:text-[12px] font-medium uppercase tracking-wide px-2 py-1 rounded';
export const billingBadgeVariant = (type: 'day_rate' | 'hourly') =>
  type === 'day_rate'
    ? 'bg-primary/10 text-primary-text border border-primary/20'
    : 'bg-transparent text-foreground/90 border border-border';
import { fieldLabelClass } from '../shared/surcharge/fieldStyles';
export { fieldLabelClass };
export const fieldSublabelClass =
  'text-[12px] sm:text-[13px] font-normal text-muted-foreground/80 leading-tight';

interface SegmentedToggleOption<T extends string> {
  value: T;
  label: string;
}

interface SegmentedToggleProps<T extends string> {
  options: readonly SegmentedToggleOption<T>[];
  value: T | null;
  onChange: (value: T) => void;
  size?: 'default' | 'sm';
}

export function SegmentedToggle<T extends string>({
  options,
  value,
  onChange,
  size = 'default',
}: SegmentedToggleProps<T>) {
  const count = options.length;
  const activeIndex = value ? options.findIndex((o) => o.value === value) : -1;

  return (
    <div className="relative border border-border rounded overflow-hidden flex bg-surface-2">
      <div
        className={cn(
          'absolute inset-y-0 bg-primary/15 transition-transform duration-200 ease-out',
          activeIndex < 0 && 'opacity-0',
        )}
        style={{
          width: `${100 / count}%`,
          transform: `translateX(${Math.max(0, activeIndex) * 100}%)`,
        }}
      />
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={cn(
            'relative z-[1] flex-1 font-mono font-medium uppercase tracking-wide transition-colors',
            'whitespace-nowrap',
            size === 'sm'
              ? 'px-3 py-2 sm:px-4 sm:py-2 text-[10px] sm:text-[12px]'
              : 'px-3 py-3 text-xs',
            value === opt.value
              ? 'text-primary-text'
              : 'text-muted-foreground hover:text-foreground',
          )}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export function FieldLabel({
  label,
  sublabel,
  className,
  style,
}: {
  label: string;
  sublabel?: string;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div className={cn(sublabel && 'space-y-1', className)} style={style}>
      <label className={fieldLabelClass}>{label}</label>
      {sublabel && <p className={fieldSublabelClass}>{sublabel}</p>}
    </div>
  );
}
